<template>
    <div>
    </div>
</template>

<script>
import IntegrationsSettingsLayout from "@layouts/IntegrationsSettingsLayout.vue";

export default {
    layout: IntegrationsSettingsLayout
}
</script>
